/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

//Custom libraries
import { MessageType } from "../constants/message";
import { useMessageSnackbar } from "../hooks/use-message-snackbar";
import { Box } from "@material-ui/core";

const CustomSnackbar = (props: any) => {
  const { t } = useTranslation();
  const { message: msg, handleClose } = useMessageSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Snackbar
      {...props}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: isMobile ? "center" : "left",
      }}
      open={!!msg}
      onClose={handleClose}
      message={
        <Box display="flex" alignItems="center">
          {msg && msg.type === MessageType.ERROR && (
            <Box px={1}>
              <ErrorOutlineIcon color="error" />
            </Box>
          )}
          {msg && msg.type === MessageType.SUCCESS && (
            <Box px={1}>
              <CheckCircleOutlineIcon htmlColor="green" />
            </Box>
          )}
          <Box>
            <Typography component="span">{msg && msg.message}</Typography>
          </Box>
        </Box>
      }
      action={
        <React.Fragment>
          <Button color="primary" size="small" onClick={handleClose}>
            {t("Common.Dismiss")}
          </Button>
        </React.Fragment>
      }
    />
  );
};

const MessageSnackbar = styled(CustomSnackbar)`
  ${({ theme }) => `

    ${theme.breakpoints.down("sm")} {
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: calc(100% - ${theme.spacing(4)}px);
    }
    
    .MuiButton-text {
      color: white;
    }
  `}
`;
export default MessageSnackbar;
